export const setBrowserTabTitle = (title, studyName) => {
  if (studyName) document.title = `${title} - ${studyName}`;
  else document.title = title;
};
export const openExternalMap = (lat, lng) => {
  if (!lat || !lng) return;
  window.open(`https://www.google.com/maps?q=${lat},${lng}`, "_blank");
};

export const hostingUrl = () =>
  window.location.origin || `${window.location.protocol}//${window.location.host}`;
